<template>
  <rest-page
    :fetch-endpoint="generateGamePreviewLink()"
    data-qa="game-preview-substep-page"
  >
    <div class="game-preview-wrapper" data-qa="game-preview-iframe-wrapper">
      <iframe
        v-if="getFrontendUrl"
        :src="getFrontendUrl"
        width="428px"
        height="926px"
        frameborder="0"
        data-qa="game-preview-iframe"
      />
    </div>
  </rest-page>
</template>
<script>
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import RestPage from '@/common/components/rest/RestPage.vue'

export default {
  name: 'GamePreviewSubStep',
  components: {
    RestPage
  },
  props: {
    saveFlag: {
      type: Boolean,
      required: true
    },
    gameCampaignId: {
      type: Number
    }
  },
  data() {
    return {
      model: {},
      isLoading: false
    }
  },
  computed: {
    isButtonDisabled() {
      return this.isLoading
    },
    getFrontendUrl() {
      if (!this.model || !this.model.preview_url) {
        return null
      }

      return this.model.preview_url
    }
  },
  watch: {
    isButtonDisabled: {
      handler(newVal) {
        this.$emit('check', newVal)
      },
      immediate: true
    },
    saveFlag: {
      async handler() {
        this.saveCampaignAsDraft()
      }
    }
  },
  methods: {
    generateGamePreviewLink() {
      return projectEndpoint({
        method: 'post',
        url: `gamify/${this.$route.params.id}/campaign/${this.gameCampaignId}/preview`,
        handler: data => {
          this.model = data
        }
      })
    },
    saveCampaignAsDraft() {
      if (!this.gameCampaignId) {
        return
      }

      this.isLoading = true

      const saveAsDraftEndpoint = projectEndpoint({
        method: 'post',
        url: `gamify/${this.$route.params.id}/campaign/${this.gameCampaignId}/state`,
        data: {
          state: 'draft'
        }
      })

      RestApi(saveAsDraftEndpoint)
        .then(() => {
          this.$message.success(this.$t('CampaignForm_Saved'))
        })
        .catch(error => {
          this.$message.error(error.message)
        })
        .finally(() => {
          this.isLoading = false
          this.$router.push(projectRoute({ name: 'GameCampaignsList' }))
        })
    }
  }
}
</script>
<style scoped>
.game-preview-wrapper {
  display: flex;
  justify-content: center;
  background-color: #f8fafc;
  border-radius: 4px;
  padding: 22px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-campaigns/preview/common/GamePreviewSubStep.vue